import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
  agreementText: {
    marginTop: 8,
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  entrepreneurSection: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 24,
  },
  nipField: {
    maxWidth: 330,
    width: '100%',
  },
}), {name: 'IkzeExtendedEntrepreneurDepositAgreement'});
